module.exports = __webpack_public_path__ + "static/media/whatsapp.3650878b.png";